const frequencyFinancialStress = [
    "Muy frecuente",
    "Frecuente",
    "Poco frecuente",
    "Casi nunca",
  ];
  
  export default frequencyFinancialStress;
  